import React from "react";
import { colors } from "../../constants/colors";

const Typography = ({
  variant = "body",
  children,
  color = colors.black,
  className = "",
  ...props
}) => {
  const getStyles = () => {
    const baseStyles = {
      margin: 0,
      color,
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    };

    switch (variant) {
      case "h1":
        return {
          ...baseStyles,
          fontSize: "clamp(2rem, 5vw, 3.5rem)",
          fontWeight: 700,
          lineHeight: 1.2,
          marginBottom: "1rem",
        };
      case "h2":
        return {
          ...baseStyles,
          fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
          fontWeight: 600,
          lineHeight: 1.3,
          marginBottom: "0.8rem",
        };
      case "h3":
        return {
          ...baseStyles,
          fontSize: "clamp(1.25rem, 3vw, 2rem)",
          fontWeight: 600,
          lineHeight: 1.4,
          marginBottom: "0.6rem",
        };
      case "subtitle":
        return {
          ...baseStyles,
          fontSize: "clamp(1rem, 2.5vw, 1.25rem)",
          fontWeight: 500,
          lineHeight: 1.5,
          opacity: 0.8,
        };
      case "body":
        return {
          ...baseStyles,
          fontSize: "clamp(0.9rem, 2vw, 1rem)",
          fontWeight: 400,
          lineHeight: 1.6,
        };
      case "small":
        return {
          ...baseStyles,
          fontSize: "clamp(0.8rem, 1.5vw, 0.875rem)",
          fontWeight: 400,
          lineHeight: 1.5,
        };
      default:
        return baseStyles;
    }
  };

  const Component = variant.startsWith("h") ? variant : "p";

  return (
    <Component style={getStyles()} className={className} {...props}>
      {children}
    </Component>
  );
};

export default Typography;
